const Footer = () => {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-6"></div>
          <div className="col-sm-6">
            <div className="text-sm-end d-none d-sm-block">
              Powered BY GenxBusinesses (info@GenxBusinesses.com | +92 320 4063600)
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
